export default "__VITE_ASSET__BxD81_Vr__"